import styled from 'styled-components';
import { OInlineMessageStatus } from './OInlineMessage.types';

interface WrapperProps {
  status: OInlineMessageStatus;
}

const getStatusStyles = (status: OInlineMessageStatus) => {
  switch (status) {
    case 'Success':
      return `
        border: 1px solid #52c41a;
        background-color: #ffffff;
      `;
    case 'Warning':
      return `
        border: 1px solid #faad14;
        background-color: #ffffff;
      `;
    case 'ErrorSev1':
      return `
        border: 1px solid #f5222d;
        background-color: #ffffff;
      `;
    case 'ErrorSev2':
      return `
        border: 1px solid #f5222d;
        background-color: #fff1f0;
      `;
    case 'Emergency':
      return `
        border: none;
        background-color: #f5222d;
        color: #ffffff;
      `;
    default:
      return `
        border: 1px solid #d9d9d9;
        background-color: #ffffff;
      `;
  }
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  border-radius: 8px;
  ${props => getStatusStyles(props.status)}
`;

export const IconWrapper = styled.div`
  margin-right: 0.75rem;
  display: flex;
  align-items: flex-start;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
`;
